/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /** 是否成功 */
  success?: boolean;
  /** 响应代码 */
  code?: number;
  /** 响应消息 */
  msg?: string;
  /** 响应数据 */
  data?: object;
}

export interface Cards {
  /**
   * The type of the card
   * @example "person"
   */
  type?: "person" | "ecosystem" | "token" | "project" | "pool" | "stock";
  /**
   * The answer type of the card
   * @example "360"
   */
  answer_type?: string;
  /** The properties of the card */
  properties?: object;
  /** Kline data for multiple tokens */
  token_kline?: Record<string, KlineEntry[]>;
  /** tvl data for multiple tokens */
  tvl?: Record<string, TvlEntry[]>;
  /** tvl data for multiple tokens */
  social_metrics?: Record<string, SocialMetricsEntity[]>;
  /**
   * Score data with dynamic keys
   * @example {"overall":85.5,"technical":78.2,"social":92.1}
   */
  score?: Record<string, number>;
  /**
   * Level data with dynamic keys
   * @example {"overall":"A","technical":"B+","social":"A+"}
   */
  level?: Record<string, string>;
}

export interface Chat {
  /** 聊天会话ID */
  id?: string;
  /** 所有者ID */
  ownerId?: string;
  /** 聊天标题 */
  title?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createdAt?: string;
  /** agentId */
  agentId?: string;
}

export interface ErrorResponse {
  /** 错误标识 */
  success?: false;
  /** 错误代码 */
  code?: number;
  /** 错误信息 */
  msg?: string;
  /** 数据为空 */
  data?: any;
}

export interface FaqShare {
  /** question */
  question?: string;
  /** question share id */
  share_id?: string;
  messages?: Message[];
  /** question answer */
  answer?: string;
  /**
   * why it moves options
   * @example ["msg_1","msg_2","msg_3"]
   */
  options?: string[];
  /** faq type */
  type?: string;
}

export interface HeaderItem {
  /**
   * The step number in the process.
   * @example 1
   */
  step: number;
  /**
   * The header or title for the step.
   * @example "NFT Platforms  "
   */
  header: string;
}

export interface KlineEntry {
  /**
   * The price of the token at the given timestamp
   * @format float
   * @example 594.802
   */
  price?: number;
  /**
   * The timestamp in milliseconds
   * @format int64
   * @example 1743838200000
   */
  timestamp?: number;
}

export interface Message {
  /** 消息ID */
  messageId?: string;
  /** 消息内容 */
  content?: string;
  /** 消息角色 */
  role?: "user" | "assistant";
  /** 消息所有者ID */
  ownerId?: string;
  /** 聊天会话ID */
  chatId?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createdAt?: string;
  /** 消息元数据 */
  metadata?: object;
  users?: User[];
  sources?: Source[];
  cards?: Cards[];
  /** 相关问题 */
  relatedQuestions?: string[];
  /** referId */
  referId?: string;
  /** status */
  status?: number;
  /** reasoning */
  reasoning?: string;
  toolInvocations?: SearchResult[];
  annotations?: (HeaderItem | SummaryItem)[];
  /** extension detail */
  extension?: Record<string, any>;
}

export interface Metadata {
  /**
   * The title of the document
   * @example "Sample Document Title"
   */
  title?: string;
  /**
   * The URL of the document
   * @format uri
   * @example "https://example.com/document"
   */
  url?: string;
  /**
   * The image URL associated with the document
   * @format uri
   * @example "https://example.com/image.jpg"
   */
  image?: string;
  /**
   * The author of the document
   * @example "John Doe"
   */
  author?: string;
  /**
   * The avatar URL of the author
   * @format uri
   * @example "https://example.com/avatar.jpg"
   */
  avatar?: string;
  /**
   * The creation timestamp of the document
   * @format date-time
   * @example "2024-01-20T12:00:00Z"
   */
  createdAt?: string;
}

export interface SearchResult {
  args: {
    /**
     * The search query or question.
     * @example "primary data sources used by AI-driven analytics tools to track voting trends in Web3 communities as of 2025"
     */
    question: string;
  };
  /**
   * The step number in the process.
   * @example 2
   */
  step: number;
  result: {
    urls: UrlItem[];
  };
  /**
   * The name of the tool used.
   * @example "TavilySearchResults"
   */
  toolName: string;
  /**
   * Unique identifier for the tool call.
   * @example "7d7542b6-5080-44cc-bb00-99d9425b0973"
   */
  toolCallId: string;
}

export interface SocialMetricsEntity {
  /**
   * Total number of followers for the user
   * @example 38506
   */
  followers_count?: number;
  /**
   * Number of smart followers for the user
   * @example 62
   */
  smart_followers_count?: number;
  /**
   * Total impressions for the user
   * @example 253865
   */
  impression?: number;
  /**
   * Rank based on follower count
   * @example 0
   */
  follower_rank?: number;
  /**
   * Rank based on smart follower count
   * @example 0
   */
  smart_follower_rank?: number;
  /**
   * Rank based on impressions
   * @example 0
   */
  impression_rank?: number;
  /**
   * Total followers aggregated across some criteria
   * @example 2
   */
  followers_total?: number;
  /**
   * Total smart followers aggregated across some criteria
   * @example 2
   */
  smart_followers_total?: number;
  /**
   * Total impressions aggregated across some criteria
   * @example 2
   */
  impressions_total?: number;
  /**
   * Timestamp of the operation in milliseconds
   * @format int64
   * @example 1744362778000
   */
  op_time?: number;
}

export interface Source {
  /**
   * The main content of the document
   * @example "This is the main content of the document"
   */
  pageContent?: string;
  metadata?: Metadata;
}

export interface SummaryItem {
  /**
   * The step number in the process.
   * @example 2
   */
  step: number;
  /**
   * A summary or description for the step.
   * @example "- 确认海绵宝宝的版权持有者   - 避免发布NFT时侵犯版权   - 版权方可能对NFT平台有特定要求"
   */
  summary: string;
}

export interface TvlEntry {
  /**
   * The price of the token at the given timestamp
   * @format float
   * @example 594.802
   */
  tvl?: number;
  /**
   * The timestamp in milliseconds
   * @format int64
   * @example 1743838200000
   */
  date?: number;
}

export interface UrlItem {
  /**
   * The URL of the search result.
   * @example "https://insight7.io/ai-primary-secondary-data-collection-tools/"
   */
  url: string;
  /**
   * The title of the webpage.
   * @example "AI for Primary & Secondary Data Collection Tools - Insight7"
   */
  title: string;
  /**
   * The URL of the favicon for the website.
   * @example "https://insight7.io/favicon.ico"
   */
  favicon: string;
  /**
   * A brief description of the webpage content.
   * @example "AI Data Collection Tools have become essential in today's data-driven world, enhancing the way organizations gather and analyze information."
   */
  description: string;
}

export interface User {
  /**
   * User's profile description or bio
   * @example "45th & 47th President of the United States. The Golden Age of America Begins Right Now."
   */
  desc?: string;
  /**
   * User's display name
   * @example "President Donald J. Trump"
   */
  name?: string;
  /**
   * URL of the user's profile picture
   * @format uri
   * @example "https://pbs.twimg.com/profile_images/1881368435453542400/NnD56DYV_normal.jpg"
   */
  avatar?: string;
  /**
   * User's unique handle or username
   * @example "POTUS"
   */
  handle?: string;
  /**
   * Source platform of the profile
   * @example "twitter"
   */
  source?: "twitter" | "facebook" | "instagram" | "linkedin";
}

export interface OnboardingStatusResponse {
  /** Onboarding 阶段，如 not_started / in_progress / completed */
  onboardingStage?: string;
}

export interface OnboardingCompleteResponse {
  /** 是否成功 */
  success?: boolean;
  /** 完成后的 stage */
  stage?: string;
}

export interface OnboardingGenerateRequest {
  /** 期望返回语言，如 zh-CN、en-US */
  language: string;
  /** 已收集的用户字段，允许自由扩展 */
  collectedFields?: Record<string, string>;
}

export interface OnboardingGenerateResponse {
  /** 诊断卡片列表 */
  diagnosticCards?: DiagnosticCard[];
}

export interface DiagnosticCard {
  /** 诊断维度 */
  dimension: "goal_match" | "portfolio_health" | "risk_violation";
  /** 诊断标题 */
  title: string;
  /** 诊断描述 */
  description: string;
  /** 严重程度 */
  severity: "high" | "medium" | "low";
}

export interface ConfirmSaveGoalRequest {
  /** Goal ID. Omit to create a new ACTIVE Goal; provide to activate or update an existing Goal */
  goalId?: string;
  /** Client-supplied idempotency key for the create branch. If two concurrent requests share the same ownerId + requestId, only one Goal is created */
  requestId?: string;
  /**
   * Goal title
   * @example "Reduce NVDA from 40% to 15%"
   */
  title: string;
  /** One-line Goal summary (mapped to tracker_goal.summary) */
  summary?: string;
  /**
   * Whether the user has bound/imported portfolio holdings
   * @default false
   */
  hasBoundPortfolio?: boolean;
  /** Progress display unit. Supported: currency codes (USD, EUR, GBP, CNY, JPY, HKD), percent sign (%), or other units such as months */
  valueUnit?: string;
  /**
   * Goal deadline as Unix epoch milliseconds; mapped to tracker_goal.deadline
   * @format int64
   */
  deadline?: number;
  /**
   * Legacy alias for deadline; server reads it as fallback but new callers should use deadline
   * @deprecated
   * @format int64
   */
  expireTime?: number;
  /** Associated account IDs */
  accountIds?: string[];
  /**
   * Metric draft list (at least 1 required)
   * @minItems 1
   */
  metrics: GoalMetricDraftInput[];
  /** Tracker specs. Required when creating or activating a Goal; when non-empty on update, replaces existing ACTIVE/STOP Trackers */
  trackerSpecs?: TrackerSpec[];
  /** Goal domain classification. Inherited by plan item trackers. Defaults to "other" when omitted */
  domain?: "finance" | "invest" | "other";
  /**
   * Deprecated: use plan_items via manage_goal tool instead. Retained for backward compatibility with older clients.
   * @deprecated
   */
  steps?: string;
  /** Goal 对 Fitness Score 的预计影响。null 时前端隐藏 delta 区域 */
  impact?: GoalImpact;
}

export interface GoalMetricDraftInput {
  /**
   * 指标 key（从 metric registry 中选择）
   * @example "max_position_pct"
   */
  metric_key: string;
  /**
   * 权重 0-1，多指标时的加权比例，默认均分
   * @example 0.5
   */
  weight?: number;
  /**
   * 目标配置（结构因 metric 而异，由 query_metric 返回的 target_schema 定义）
   * @example {"single_position_cap_pct":15}
   */
  target_config: object;
}

export interface TrackerSpec {
  /** Tracker 标题 */
  title: string;
  /** Tracker 描述 */
  description?: string;
  condition_logic: "AND" | "OR";
  conditions: {
    condition_type: "tag_match" | "numeric" | "semantic" | "schedule";
    match_key?: string;
    match_op?: string;
    match_values?: string[];
    schedule_expr?: string;
    schedule_payload?: string;
  }[];
  created_by?: "USER_CLICK" | "AI_DIALOG";
  user_raw_input?: string;
  /** JSON-stringified tracker payload (version, task_description, content, action_label, etc.) */
  payload?: string;
  /** Who owns this tracker. USER = user-facing plan item, SYSTEM = system monitor */
  actor?: "USER" | "SYSTEM";
  /** Tracker domain classification (e.g. finance, invest) */
  domain?: string;
  /**
   * Tracker start time as Unix epoch milliseconds
   * @format int64
   */
  start?: number;
  /**
   * Tracker end time as Unix epoch milliseconds; null means open-ended
   * @format int64
   */
  end?: number | null;
}

export interface ConfirmSaveGoalResponse {
  /** 创建或确认后的 Goal ID */
  goalId?: string;
  /** Goal 标题 */
  title?: string;
  /** 完整的 GoalMetricsPayload（含 common、target_data、calculation_data） */
  metrics?: {
    items?: object[];
  };
  /**
   * 确认请求处理时间（Unix 毫秒时间戳）
   * @format int64
   */
  createdAt?: number;
  /** V3.0.1 新增：Goal 的实际保存状态。分支 2（INACTIVE draft 确认）时根据会员状态返回 ACTIVE 或 PLANNED */
  status?: "ACTIVE" | "PLANNED";
  /** V3.0.1 新增：用户会员等级（如 FREE, COMPLETE）。分支 2 时查询 Member API 返回 */
  productLevel?: string;
}

export interface ActivateGoalResponse {
  /** 激活后的 Goal ID */
  goalId: string;
  /** 始终为 ACTIVE */
  status: "ACTIVE";
  /** Runtime readiness after activation; only ACTIVE and READY is a completed activation. */
  runtimeStatus: "READY";
  runtimeOwner: "goal_steward";
  idempotent: boolean;
  correlationId: string;
  /** 新创建的 "goal_live" 承接 chat ID */
  chatId?: string;
}

export interface ActivateGoalRequest {
  /** User entry point for this activation. */
  source: "chat" | "signal" | "plan" | "my_goals";
  /** Stable client idempotency key used for activation retry. */
  idempotencyKey?: string;
}

export interface GoalSignal {
  signalId: string;
  title: string;
  summary: string;
  content: string;
  eventType: string;
  /** @format int64 */
  createdAt: number;
  /** @format int64 */
  readAt: number | null;
  refinementRequired?: boolean;
}

export interface GoalSignalPagination {
  goalId: string;
  rows: GoalSignal[];
  nextToken: string | null;
}

export interface GoalSignalReadSettlement {
  goalId: string;
  settledCount: number;
  unreadCount: number;
  /** @format int64 */
  readAt: number | null;
}

export interface GoalErrorResponse {
  code?: string;
  /** 错误信息 */
  error?: string;
  retryable?: boolean;
  goalId?: string;
  goalStatus?: "INACTIVE" | "PLANNED" | "ACTIVE" | "COMPLETED" | "DELETED";
  runtimeStatus?: "RECOVERING" | "FAILED";
  /** @min 1 */
  retryAfterMs?: number;
  correlationId?: string;
}

export interface FitnessScoreApiResponse {
  /**
   * 总分 0–100
   * @example 72
   */
  total?: number;
  /**
   * Control 维度分 0–100
   * @example 78
   */
  control?: number;
  /**
   * Safety 维度分 0–100
   * @example 70
   */
  safety?: number;
  /**
   * Growth 维度分 0–100
   * @example 68
   */
  growth?: number;
  /**
   * true=Onboarding 数据不完整（仅基础题），部分子指标未算
   * @example true
   */
  partial?: boolean;
  /**
   * Ed 读数，≤8 词
   * @example "More okay than you feel"
   */
  headline?: string;
  /**
   * 数据来源说明
   * @example "A quick read from your answers."
   */
  scoreBasis?: string;
}

/** Goal 对 Fitness Score 的预计影响。null 时前端隐藏 delta 区域 */
export type GoalImpact = {
  /**
   * 预计分数变化
   * @example 8
   */
  delta?: number;
  /**
   * 受影响维度
   * @example ["control","safety"]
   */
  dimensions?: ("control" | "safety" | "growth")[];
} | null;

export interface VaultFile {
  id: string;
  name: string;
  kind: "documents" | "images";
  /** Upper-case file extension, e.g. PDF / CSV / JPG */
  format: string;
  mediaType?: string;
  sizeBytes?: number;
  /** @format date-time */
  sharedAt: string;
  /** Signed content URL, valid for 1 hour; 403 after expiry */
  contentUrl: string;
  /** Signed thumbnail URL, images only */
  thumbUrl?: string | null;
}

export interface VaultFileCounts {
  all: number;
  documents: number;
  images: number;
}

export interface VaultFileList {
  /** @format date-time */
  generatedAt: string;
  counts: VaultFileCounts;
  /** All logical files of the user, sharedAt descending */
  files: VaultFile[];
}

/** Body of POST /vault/files:delete. The path is not declared under paths because swagger-typescript-api reads ":delete" as a path parameter; the call goes through ChatClient.request in features/vault/vaultApi.ts. */
export interface VaultDeleteRequest {
  ids: string[];
  /**
   * generatedAt of the list shown when the confirm dialog opened
   * @format date-time
   */
  asOf: string;
}

export interface VaultDeleteResult {
  deletedIds: string[];
}

export interface VaultFileListResponse {
  success?: boolean;
  code?: number;
  msg?: string;
  data?: VaultFileList;
}

export interface VaultDeleteResponse {
  success?: boolean;
  code?: number;
  msg?: string;
  data?: VaultDeleteResult;
}

export type undefined = undefined;

export type Properties = any;

export type Required = any;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Perplexica API
 * @version 1.0.0
 * @baseUrl /api/v1
 * @contact Perplexica Team
 *
 * Perplexica 服务端 API 文档
 */
export class ChatClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  member = {
    /**
     * No description
     *
     * @tags member
     * @name EquityList
     * @summary get member equity
     * @request GET:/member/equity
     */
    equityList: (params: RequestParams = {}) =>
      this.request<
        ApiResponse & {
          data?: {
            equities?: {
              equity_id?: string;
              category?: string;
              /** total available usage count */
              count?: number;
              /** remaining usage count */
              remaining?: number;
            }[];
          };
        },
        any
      >({
        path: `/member/equity`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  pairs = {
    /**
     * No description
     *
     * @tags pairs
     * @name PairsDetail
     * @summary Get pair technical analysis scores and report share id (batch query)
     * @request GET:/pairs/{exchange}/{type}
     */
    pairsDetail: (
      exchange: string,
      type: "short" | "medium" | "long",
      query: {
        /** 交易对列表，支持多个交易对批量查询 */
        pairs: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data?: Record<
            string,
            {
              rsi_score?: string;
              rsi_reason?: string;
              ema_score?: string;
              ema_reason?: string;
              macd_score?: string;
              macd_reason?: string;
              summary_score?: string;
              shareId?: string;
            }
          >;
        },
        any
      >({
        path: `/pairs/${exchange}/${type}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  stream = {
    /**
     * No description
     *
     * @tags stream
     * @name StopCreate
     * @summary 停止流式对话
     * @request POST:/stream/stop
     * @secure
     */
    stopCreate: (
      data: {
        /** 聊天会话ID */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiResponse, any>({
        path: `/stream/stop`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  chats = {
    /**
     * No description
     *
     * @tags chats
     * @name ChatsList
     * @summary 获取聊天列表
     * @request GET:/chats
     * @secure
     */
    chatsList: (
      query?: {
        /** 返回结果数量限制 */
        limit?: number;
        /** 翻页的offset */
        offset?: number;
        /** 1 查询收藏列表 */
        mark?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            chats?: Chat[];
          };
        },
        any
      >({
        path: `/chats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags chats
     * @name ChatsDetail
     * @summary 获取特定聊天会话
     * @request GET:/chats/{id}
     * @secure
     */
    chatsDetail: (
      id: string,
      query?: {
        /**
         * 消息数量限制
         * @default 20
         */
        limit?: number;
        /** 游标，加载此消息 id 之前的更早消息；首屏不传 */
        startId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            messages?: Message[];
          };
        },
        ErrorResponse
      >({
        path: `/chats/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags chats
     * @name ChatsUpdate
     * @summary 修改聊天会话
     * @request PUT:/chats/{id}
     * @secure
     */
    chatsUpdate: (
      id: string,
      data: {
        /** 修改名称 */
        title?: string;
        /** 取消收藏、收藏、 */
        mark?: 0 | 1;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiResponse, ErrorResponse>({
        path: `/chats/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags chats
     * @name ChatsDelete
     * @summary 删除聊天会话
     * @request DELETE:/chats/{id}
     * @secure
     */
    chatsDelete: (id: string, params: RequestParams = {}) =>
      this.request<ApiResponse, void>({
        path: `/chats/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags chats
     * @name MessagesDetail
     * @summary 获取message详情
     * @request GET:/chats/{id}/messages/{messageId}
     */
    messagesDetail: (
      id: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            message?: Message;
          };
        },
        ErrorResponse
      >({
        path: `/chats/${id}/messages/${messageId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags chats
     * @name MessagesAgentsList
     * @summary 获取指定 message 的 MessageAgent 列表
     * @request GET:/chats/{id}/messages/{messageId}/agents
     */
    messagesAgentsList: (
      id: string,
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            /** 聊天会话ID */
            chatId?: string;
            /** 消息ID */
            messageId?: string;
            agents?: any[];
          };
        },
        ErrorResponse
      >({
        path: `/chats/${id}/messages/${messageId}/agents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 对特定消息提供点赞或点踩反馈
     *
     * @tags feedback
     * @name FeedbackCreate
     * @summary 提供消息反馈
     * @request POST:/chats/feedback/{messageId}
     * @secure
     */
    feedbackCreate: (
      messageId: string,
      data: {
        /** 反馈类型 */
        type: "thumb_up" | "thumb_down";
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiResponse, ErrorResponse>({
        path: `/chats/feedback/${messageId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  share = {
    /**
     * @description Validate message IDs, create a random share ID, and store in Redis
     *
     * @tags share
     * @name ShareCreate
     * @summary 创建分享会话
     * @request POST:/share
     */
    shareCreate: (
      data: {
        /**
         * Unique identifier for the chat
         * @example "chat_123"
         */
        chatId: string;
        /**
         * List of message IDs to be shared
         * @example ["msg_1","msg_2","msg_3"]
         */
        ids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * Operation success status
           * @example true
           */
          success?: boolean;
          data?: {
            /**
             * Generated random share ID
             * @example "a1b2c3d"
             */
            shareId?: string;
          };
        },
        | ErrorResponse
        | (
            | ErrorResponse
            | {
                /** @example false */
                success?: boolean;
                /** @example "params error, ids query message error" */
                message?: string;
              }
          )
      >({
        path: `/share`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 通过分享ID获取分享的对话内容
     *
     * @tags share
     * @name ShareDetail
     * @summary 获取分享的对话
     * @request GET:/share/{shareId}
     */
    shareDetail: (shareId: string, params: RequestParams = {}) =>
      this.request<
        ApiResponse & {
          data?: {
            messages?: Message[];
            /** 对话标题 */
            title?: string;
          };
        },
        ErrorResponse
      >({
        path: `/share/${shareId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  type = {
    /**
     * @description Obtain the token issue and its cached sharing information
     *
     * @tags share
     * @name ShareList
     * @summary Obtain the token issue and its cached sharing information
     * @request GET:/{type}/share/
     */
    shareList: (
      type?: string,
      query?: {
        /** token symbol,such as BTC */
        symbol?: string;
        /** user language */
        language?: string;
        /** token name,such as Bitcoin */
        name?: string;
        /** stock company,such as apple */
        company?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: FaqShare[];
        },
        any
      >({
        path: `/${type}/share/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  discover = {
    /**
     * @description 获取推荐的公开对话和热门话题
     *
     * @tags discover
     * @name DiscoverList
     * @summary 获取发现页内容
     * @request GET:/discover
     */
    discoverList: (
      query?: {
        /**
         * 页码
         * @default 1
         */
        page?: number;
        /**
         * 每页数量
         * @default 20
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            blogs?: (Chat & {
              /** 标题 */
              title?: string;
              /** 链接 */
              url?: string;
              /** 图片源链接 */
              img_src?: string;
              /** 缩略图源链接 */
              thumbnail_src?: string;
              /** 缩略图 */
              thumbnail?: string;
              /** 内容 */
              content?: string;
              /** 作者 */
              author?: string;
              /** iframe 源链接 */
              iframe_src?: string;
              /**
               * 发布日期（ISO 8601 格式：yyyy-MM-dd'T'HH:mm:ss.SSSXXX）
               * @format date-time
               */
              publishedDate?: string;
              /** 头像链接 */
              avatar?: string;
            })[];
          };
        },
        any
      >({
        path: `/discover`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  chatId = {
    /**
     * @description 生成新的聊天会话ID，不需要登录
     *
     * @tags chat-id
     * @name ChatIdCreate
     * @summary 创建新的聊天会话
     * @request POST:/chat-id
     */
    chatIdCreate: (
      data: {
        /** 分享id */
        shareId?: string;
        /** agentId */
        agentId?: string;
        /** 是否为首次创建聊天会话 */
        firstChat?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ApiResponse & {
          data?: {
            /** 新生成的聊天会话ID */
            chatId?: string;
            /** 用户ID（可以是已登录用户ID或访客ID） */
            userId?: string;
          };
        },
        ErrorResponse
      >({
        path: `/chat-id`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  cards = {
    /**
     * @description get cards token info
     *
     * @tags cards
     * @name CardsDetail
     * @summary get cards token info
     * @request GET:/cards/{chatId}/{messageId}/{type}/{index}
     */
    cardsDetail: (
      chatId: string,
      messageId: string,
      type: "ecosystem" | "token",
      index: string,
      query: {
        /** token symbols */
        symbols: string[];
        /** Enrich sparkline data for the specified range (30d or 24h) */
        enrichSparkline?: "30d" | "24h";
        /** enrich team members and investors */
        enrichTeamMembersAndInvestors?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiResponse, ErrorResponse>({
        path: `/cards/${chatId}/${messageId}/${type}/${index}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * @description 冷启动时调用，判断用户当前的 Onboarding 阶段
     *
     * @tags onboarding
     * @name OnboardingStatusList
     * @summary 获取 Onboarding 状态
     * @request GET:/user/onboarding-status
     * @secure
     */
    onboardingStatusList: (params: RequestParams = {}) =>
      this.request<OnboardingStatusResponse, ErrorResponse>({
        path: `/user/onboarding-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  onboarding = {
    /**
     * @description 标记当前用户的 Onboarding 流程为已完成
     *
     * @tags onboarding
     * @name CompleteCreate
     * @summary 完成 Onboarding
     * @request POST:/onboarding/complete
     * @secure
     */
    completeCreate: (params: RequestParams = {}) =>
      this.request<OnboardingCompleteResponse, ErrorResponse>({
        path: `/onboarding/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 基于已保存的 Goal 和用户持仓信息生成诊断卡片（hasBoundPortfolio=true 时调用）
     *
     * @tags onboarding
     * @name GenerateCreate
     * @summary 生成诊断卡片
     * @request POST:/onboarding/generate
     * @secure
     */
    generateCreate: (
      data: OnboardingGenerateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OnboardingGenerateResponse, ErrorResponse>({
        path: `/onboarding/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 前端 Loading 页调用。确定性计算激励型 Result values， 同时异步启动 Plan Preview agent 生成。返回 resultValues + previewId。 fire-and-forget 保存用户数据到 memory/preference（stage=data_collected； completed 在 plan-preview GET 成功时标记）。 V3.0.1 六类为纯问卷计算，包含 3 秒最小响应延迟以保证 Loading 动画； V3.0.6 新增 spending/invest 需先读取 linked 金融数据（仅此两类无人工延迟）。 可选 clientVersion 仅用于服务端日志/埋点区分客户端版本，不参与任何行为分支。
     *
     * @tags onboarding
     * @name V3GenerateCreate
     * @summary 生成 Result Values + 异步启动 Plan Preview
     * @request POST:/onboarding/v3/generate
     * @secure
     */
    v3GenerateCreate: (
      data: {
        /** 可选客户端版本标识（如 "3.0.6"），仅打日志，缺失视为旧客户端 */
        clientVersion?: string;
        /**
         * V3.0.6 新增 spending（现金漏损三桶）与 invest（持仓集中度）。
         * emergency：V3.0.9 起**正式在用**，不再是历史值。
         * `scene=ai_job_risk` 的广告支没有「选目标」屏，goalType 由后端 band 判定产出
         * （PRD A.4：band=A → emergency / B → idlecash / C → retirement），
         * band 与 goalType 同源，前端不重算、不提交。
         * 默认场景（用户自选目标）的七个选项里仍然没有 emergency，用户选不到。
         */
        goalType:
          | "million"
          | "retirement"
          | "emergency"
          | "idlecash"
          | "home"
          | "debt"
          | "spending"
          | "invest";
        answers: {
          /** @minLength 1 */
          name: string;
          /**
           * @min 16
           * @max 100
           */
          age: number;
          /**
           * 有限非负金额；可以为 0，非零时至少为 0.01
           * @min 0
           * @max 8796093022207
           */
          annualIncome: number;
          /**
           * 有限非负金额；可以为 0，非零时至少为 0.01
           * @min 0
           * @max 8796093022207
           */
          monthlyExpense: number;
          /**
           * 有限非负金额；可以为 0，非零时至少为 0.01
           * @min 0
           * @max 8796093022207
           */
          cash: number;
          /**
           * 有限非负金额；可以为 0，非零时至少为 0.01
           * @min 0
           * @max 8796093022207
           */
          debt: number;
          /**
           * 有限非负金额；可以为 0，非零时至少为 0.01
           * @min 0
           * @max 8796093022207
           */
          invested: number;
          riskProfile: "safe" | "balanced" | "growth";
        };
        context: {
          /** @example "USD" */
          currency?: string;
          /** @example "en-US" */
          language?: string;
        };
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          resultValues?: {
            goalType?: string;
            /**
             * goalType 对应的 Result values（schema 因 goalType 而异）。当 goalType 为 debt 时，
             * 包含 debtAmount、onYourOwnMonths、withEdMonths、deltaMonths、onYourOwnYear、
             * withEdYear 和 chart。月份字段为向上取整后的整数，适合直接用于还款期限展示；
             * 年份字段保留用于兼容展示。million/retirement 的 deltaMonths 是未取整投影期限的
             * 总月份差；deltaMonths 不足 12 时 deltaYears 为 0，否则 deltaYears 为月份差换算后的
             * 四舍五入整年，用于现有前端选择“月”或“年”的展示单位。
             */
            values?: object;
          };
          /** Plan Preview 异步任务 ID，用于 GET /plan-preview/:previewId */
          previewId?: string;
          /**
           * 展示安全的储蓄率百分数，例如 24 表示 24%；极端赤字最低为 -100
           * @min -100
           * @max 100
           */
          savingsRate?: number;
          fitnessScore?: FitnessScoreApiResponse;
        },
        | ErrorResponse
        | {
            error?: string;
            code?: "NO_VISIBLE_HOLDINGS";
          }
      >({
        path: `/onboarding/v3/generate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 阻塞等待 Plan Preview 生成完成（内部轮询 Redis，最多 60 秒）。 首次成功获取时自动创建 INACTIVE goal draft，并自动标记 onboarding 为 completed。 如果上一次异步生成失败，会自动触发一次重试。 V3.0.6：plan items 全量返回（visible 恒 true，不再截断为 2 条）； 响应额外回放 resultValues/savingsRate/fitnessScore（与 generate 响应同值， 供合并后的 Result 页冷启动恢复，旧客户端可忽略多余字段）。
     *
     * @tags onboarding
     * @name V3PlanPreviewDetail
     * @summary 获取 Plan Preview（V3.0.6 含 Result 回放）
     * @request GET:/onboarding/v3/plan-preview/{previewId}
     * @secure
     */
    v3PlanPreviewDetail: (previewId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** 用户目标的一句话标题 */
          title?: string;
          /** 方案摘要 */
          summary?: string;
          /** 3–5 条 move，顺序有意义（先长期生效后需人工） */
          planItems?: {
            title?: string;
            description?: string;
            /** Markdown 正文 */
            content?: string;
            /** V3.0.6 起恒为 true（Plan 全部免费可见） */
            visible?: boolean;
          }[];
          /** INACTIVE goal draft ID */
          draftId?: string;
          /** Goal 对 Fitness Score 的预计影响。null 时前端隐藏 delta 区域 */
          impact?: GoalImpact;
          /**
           * V3.0.6 加法回放字段，与 generate 响应同值。
           * { goalType, values }，values 结构随 goalType 变化；
           * spending 为两桶/三桶结构，invest 为集中度/覆盖/前后饼图结构。
           */
          resultValues?: {
            goalType?: string;
            values?: object;
          };
          /** V3.0.6 加法回放字段，问卷派生储蓄率百分数 */
          savingsRate?: number;
          fitnessScore?: FitnessScoreApiResponse;
        },
        | ErrorResponse
        | {
            error?: "PREVIEW_NOT_FOUND";
            message?: string;
          }
        | {
            error?: "PREVIEW_TIMEOUT";
            message?: string;
          }
      >({
        path: `/onboarding/v3/plan-preview/${previewId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  goals = {
    /**
     * @description 前端用户确认 Goal 卡片后调用此接口。 Perplexica 将 GoalMetricDraftInput[] 转换为完整的 GoalMetricsPayload （填充 common、target_data、calculation_data 通用字段），然后调用 tracker Goal API。 **分支语义（V3.0.1 改造后两个分支）**： - 不传 goalId：创建新的 ACTIVE Goal，调用下游 `POST /v2/tracker/goals`，`trackerSpecs` 必填。 - 传 goalId 且现有 Goal 为 INACTIVE：查询用户会员状态 (productLevel)； 已付费 → 激活为 ACTIVE + 创建 trackers + 创建 "goal_live" 承接 chat； 未付费 → 保存为 PLANNED + 创建 "goal_saved" 承接 chat（不创建 trackers）。 **已删除**: 传 goalId 且现有 Goal 为 ACTIVE/PLANNED/COMPLETED 的更新分支已移除，返回 409。 **requestId**: Optional client-supplied idempotency key. Used only in the create branch to deduplicate concurrent requests with the same ownerId + requestId. If omitted, a server-generated request_id is used for the downstream API call. **触发方式**：此接口由 save_goal 交互式工具的前端组件调用，不由模型直接调用。
     *
     * @tags goals
     * @name ConfirmSaveCreate
     * @summary 确认保存 Goal
     * @request POST:/goals/confirm-save
     * @secure
     */
    confirmSaveCreate: (
      data: ConfirmSaveGoalRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConfirmSaveGoalResponse, GoalErrorResponse>({
        path: `/goals/confirm-save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 前端在用户付费成功后调用，将 PLANNED 状态的 Goal 真正激活。 激活操作包括：更新 status 为 ACTIVE、创建 trackers (system monitors)、 生成 diagnosis content、创建 "goal_live" 承接 chat。 仅 PLANNED 状态的 Goal 可被激活，其他状态返回 409。
     *
     * @tags goals
     * @name ActivateCreate
     * @summary 激活 PLANNED Goal
     * @request POST:/goals/{goalId}/activate
     * @secure
     */
    activateCreate: (
      goalId: string,
      data: ActivateGoalRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActivateGoalResponse, GoalErrorResponse>({
        path: `/goals/${goalId}/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags goals
     * @name ListGoalSignals
     * @summary List goal signals
     * @request GET:/goals/{goalId}/signals
     */
    listGoalSignals: (
      goalId: string,
      query?: {
        /**
         * @min 1
         * @max 50
         * @default 20
         */
        limit?: number;
        /** Opaque pagination cursor; return it unchanged for the next page. */
        nextToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GoalSignalPagination, any>({
        path: `/goals/${goalId}/signals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags goals
     * @name GetGoalSignal
     * @summary Get goal signal detail
     * @request GET:/goals/{goalId}/signals/{signalId}
     */
    getGoalSignal: (
      goalId: string,
      signalId: string,
      params: RequestParams = {},
    ) =>
      this.request<GoalSignal, any>({
        path: `/goals/${goalId}/signals/${signalId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags goals
     * @name MarkGoalSignalsRead
     * @summary Mark goal signals read
     * @request POST:/goals/{goalId}/signals/read
     */
    markGoalSignalsRead: (goalId: string, params: RequestParams = {}) =>
      this.request<GoalSignalReadSettlement, any>({
        path: `/goals/${goalId}/signals/read`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  vault = {
    /**
     * No description
     *
     * @tags vault
     * @name ListVaultFiles
     * @summary List the files the user shared with Ed
     * @request GET:/vault/files
     */
    listVaultFiles: (params: RequestParams = {}) =>
      this.request<VaultFileListResponse, any>({
        path: `/vault/files`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
